import { render, staticRenderFns } from "./MaterialRevealCard.vue?vue&type=template&id=0cda9af1"
import script from "./MaterialRevealCard.vue?vue&type=script&lang=js"
export * from "./MaterialRevealCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialRevealCard.vue?vue&type=style&index=0&id=0cda9af1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports